/* Email signup pop-up (sections/bs-signup-popup.liquid).
   - Waits until the age check is passed. On the first page of a visit it needs both the delay and the scroll depth;
     from the second page either one, or (desktop) exit intent. It never opens over an open menu, cart, filter
     panel, form field, chat or dialog: it waits until the visitor is done (see Opening rules).
   - Closing it starts the cooldown and shows the corner tab. Signing up hides both for good on this browser.
   - Checks the email, then lets the Shopify customer form send normally. Shopify's spam protection (hCaptcha)
     takes over valid customer forms, so sending in the background isn't possible. When the page comes back with
     customer_posted=true, the pop-up opens on the thank-you step.
   - Fires a "bs:signup" event on document after a signup, for analytics. */
(function () {
  var root = document.querySelector('[data-bs-pop]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var dialog = root.querySelector('[data-bs-pop-dialog]');
  var card = root.querySelector('.bs-pop__card');
  var form = root.querySelector('form');
  var email = root.querySelector('#bs-pop-email');
  var submit = root.querySelector('[data-bs-pop-submit]');
  var errorEl = root.querySelector('[data-bs-pop-error]');
  var teaser = root.querySelector('[data-bs-pop-teaser]');
  var design = root.dataset.design === 'true';
  var cooldown = (parseInt(root.dataset.cooldown, 10) || 7) * 86400000;
  var opened = false;
  var lastFocus = null;
  var hideTimer = null;

  var store = {
    get: function (k) { try { return window.localStorage.getItem('bsPop' + k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem('bsPop' + k, v); } catch (e) {} }
  };
  function subscribed() { return store.get('Subscribed') === '1'; }
  function recently(key) {
    var t = parseInt(store.get(key) || '0', 10);
    return t > 0 && Date.now() - t < cooldown;
  }
  function ageGateOpen() {
    var w = document.querySelector('.agp__wrapper');
    return !!w && document.contains(w) && getComputedStyle(w).display !== 'none';
  }

  function setStep(name) {
    root.querySelectorAll('[data-bs-pop-step]').forEach(function (s) { s.hidden = s.getAttribute('data-bs-pop-step') !== name; });
    dialog.setAttribute('aria-labelledby', name === 'done' ? 'bs-pop-done-title' : 'bs-pop-title');
    var doneTitle = root.querySelector('[data-bs-pop-done-title]');
    if (doneTitle) doneTitle.id = 'bs-pop-done-title';
  }

  function focusables() {
    return Array.prototype.filter.call(card.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'), function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || !card.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(step) {
    if (opened) return;
    opened = true;
    clearTimeout(hideTimer);
    lastFocus = document.activeElement;
    setStep(step || 'form');
    if (teaser) teaser.hidden = true;
    dialog.hidden = false;
    void dialog.offsetWidth;
    dialog.classList.add('is-open');
    document.documentElement.classList.add('bs-pop-lock');
    document.addEventListener('keydown', onKey);
    var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    setTimeout(function () {
      var target = step === 'done' ? root.querySelector('[data-bs-pop-done-title]') : (touch ? card : email);
      try { (target || card).focus({ preventScroll: true }); } catch (e) {}
    }, 60);
  }

  function close(remember) {
    if (!opened) return;
    opened = false;
    dialog.classList.remove('is-open');
    document.documentElement.classList.remove('bs-pop-lock');
    document.removeEventListener('keydown', onKey);
    hideTimer = setTimeout(function () { dialog.hidden = true; }, 220);
    if (remember !== false && !subscribed()) {
      store.set('Closed', String(Date.now()));
      showTeaser();
    }
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function showTeaser() {
    if (!teaser || subscribed() || recently('TeaserOff')) return;
    if (root.dataset.product === 'true' && window.matchMedia('(max-width: 749px)').matches) return;
    teaser.hidden = false;
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
    email.setAttribute('aria-invalid', 'true');
    email.setAttribute('aria-describedby', 'bs-pop-error bs-pop-fine');
    email.focus();
  }
  function clearError() {
    errorEl.hidden = true;
    email.removeAttribute('aria-invalid');
    email.setAttribute('aria-describedby', 'bs-pop-fine');
  }

  function done() {
    store.set('Subscribed', '1');
    if (teaser) teaser.hidden = true;
    if (!opened) open('done');
    else {
      setStep('done');
      var t = root.querySelector('[data-bs-pop-done-title]');
      if (t) try { t.focus({ preventScroll: true }); } catch (e) {}
    }
    try { document.dispatchEvent(new CustomEvent('bs:signup', { detail: { source: 'popup' } })); } catch (e) {}
  }

  /* Runs before Shopify's own handler (capture phase), so a bad email never gets sent */
  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    var value = email.value.trim();
    email.value = value;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError('Enter a valid email address, like name@example.com.');
      return;
    }
    clearError();
    store.set('Pending', String(Date.now()));
    submit.setAttribute('aria-busy', 'true');
  }, true);
  window.addEventListener('pageshow', function () { submit.removeAttribute('aria-busy'); });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-bs-pop-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-bs-pop-open]')) { e.preventDefault(); open('form'); return; }
    if (e.target.closest('[data-bs-pop-teaser-close]')) {
      e.preventDefault();
      store.set('TeaserOff', String(Date.now()));
      teaser.hidden = true;
      return;
    }
    var copy = e.target.closest('[data-bs-pop-copy]');
    if (copy) {
      var code = root.querySelector('[data-bs-pop-code]');
      if (code && navigator.clipboard) {
        navigator.clipboard.writeText(code.textContent.trim()).then(function () {
          copy.textContent = 'Copied';
          setTimeout(function () { copy.textContent = 'Copy code'; }, 2000);
        });
      }
    }
  });
  email.addEventListener('input', function () { if (!errorEl.hidden) clearError(); });

  /* Opening rules
     - Never straight after the age check: the clock only starts once it has been passed.
     - First page of a visit: only once the visitor has stayed the set time AND scrolled the set depth.
       From the second page on: after either one, or (desktop) when the visitor heads to leave the page.
     - Never on top of something in use. While a menu, the cart, the filters, a form field (search included),
       the chat or another dialog is open, it waits, and opens once the visitor has been done for 3 seconds. */
  var browsed = false;

  function onScreen(el) {
    if (!el || !document.contains(el)) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.right > 0 && r.left < window.innerWidth && r.bottom > 0 && r.top < window.innerHeight;
  }
  function busy() {
    if (document.hidden || ageGateOpen()) return true;
    if (document.querySelector('[data-bs-disclosure][aria-expanded="true"], [data-js-sidebar-handle][aria-expanded="true"]')) return true;
    if (document.body.classList.contains('bs-sheet-open')) return true;
    var layers = document.querySelectorAll('sidebar-drawer, .bs-sheet.is-open, dialog[open], shopify-chat[open]');
    for (var i = 0; i < layers.length; i++) {
      if (layers[i].tagName === 'SHOPIFY-CHAT' || onScreen(layers[i])) return true;
    }
    var a = document.activeElement;
    if (a && a !== document.body && !root.contains(a) && a.matches('input:not([type="hidden"]), textarea, select, [contenteditable="true"]')) return true;
    return false;
  }

  var waitTimer = null;
  function openWhenFree() {
    if (opened || subscribed()) return;
    if (!busy()) { open('form'); return; }
    var quiet = 0;
    clearInterval(waitTimer);
    waitTimer = setInterval(function () {
      if (opened || subscribed()) { clearInterval(waitTimer); return; }
      if (busy()) { quiet = 0; return; }
      quiet += 1;
      if (quiet >= 3) { clearInterval(waitTimer); open('form'); }
    }, 1000);
  }

  var armed = false;
  function arm() {
    if (armed) return;
    armed = true;
    var delay = (parseInt(root.dataset.delay, 10) || 20) * 1000;
    var depth = parseInt(root.dataset.scroll, 10) || 50;
    var timeOk = false;
    var scrollOk = false;
    var fired = false;
    var timer = null;
    function fire() {
      if (fired) return;
      fired = true;
      cleanup();
      openWhenFree();
    }
    function check() {
      if (browsed ? (timeOk || scrollOk) : (timeOk && scrollOk)) fire();
    }
    function onScroll() {
      var h = document.documentElement;
      var room = h.scrollHeight - window.innerHeight;
      /* A page too short to scroll counts as read */
      if (room < 200 || (window.scrollY || h.scrollTop) / room * 100 >= depth) {
        scrollOk = true;
        window.removeEventListener('scroll', onScroll);
        check();
      }
    }
    function onLeave(e) { if (!e.relatedTarget && e.clientY <= 0 && (browsed || timeOk)) fire(); }
    function cleanup() {
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onLeave);
    }
    timer = setTimeout(function () { timeOk = true; check(); }, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (root.dataset.exit === 'true' && window.matchMedia && window.matchMedia('(pointer: fine)').matches) document.addEventListener('mouseout', onLeave);
  }
  function startWhenAgeGateClears() {
    if (!ageGateOpen()) { arm(); return; }
    var poll = setInterval(function () {
      if (!ageGateOpen()) { clearInterval(poll); arm(); }
    }, 500);
  }

  /* Theme editor: open while the section is selected */
  if (design) {
    document.addEventListener('shopify:section:select', function (e) { if (root.closest('.shopify-section') === e.target || e.target.contains(root)) open('form'); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(root)) close(false); });
    return;
  }

  /* Back from sending: a signup from this pop-up (sent in the last 30 minutes) gets the thank-you step;
     a signup from the footer form just stops the pop-up */
  var pending = parseInt(store.get('Pending') || '0', 10);
  var fromPopup = pending > 0 && Date.now() - pending < 1800000;
  if (/customer_posted=true/.test(window.location.search) || root.querySelector('[data-bs-pop-posted]')) {
    store.set('Pending', '0');
    if (fromPopup) done();
    else store.set('Subscribed', '1');
    return;
  }
  if (!errorEl.hidden && fromPopup) { store.set('Pending', '0'); open('form'); return; }
  /* Pages seen in this visit (this tab), so the first page can be held to the stricter rule */
  var pages = 1;
  try {
    pages = (parseInt(window.sessionStorage.getItem('bsPopPages') || '0', 10) || 0) + 1;
    window.sessionStorage.setItem('bsPopPages', String(pages));
  } catch (e) {}
  browsed = pages >= 2;
  if (subscribed()) return;
  if (recently('Closed')) { showTeaser(); return; }
  startWhenAgeGateClears();
})();
